<template>
  <div>
    <img
      v-if="channelsImage != null && channelsImage != ''"
      v-tooltip:top="getTooltip(channelsLogoName)"
      :data-original-title="getTooltip(channelsLogoName)"
      data-toggle="modal"
      data-target="#exampleModalLabel"
      :src="channelsImage"
      class="image_box"
      @click="showImage(channelsImage)"
    >
    <img
      v-else
      v-tooltip:top="getTooltip(channelsLogoName)"
      :data-original-title="getTooltip(channelsLogoName)"
      :src="$storeIndex.getImageSrc('icon-gosell')"
      class="image_box"
    >
  </div>
</template>

<script>
export default {
  props: {
    productId:{
      type: [Number, String],
      default: undefined
    },
    channelsImageUrl: {
      type: [Object, Array, String],
      default: null
    },
    channelsName: {
      type: [String],
      default: null
    }
  },
  data() {
    return {
      channelsImage: "",
      isModalImages: false,
      showBigImage: "",
      channelsLogoName: ""
    };
  },
  mounted() {
  },
  watch: {
    channelsImageUrl: {
      immediate: true,
      handler(val) {
        this.getImage(val);
      },
    },
    channelsName: {
      immediate: true,
      handler(current, old) {
        this.channelsLogoName = current
      },
    },
  },
  methods: {
    getImage(dataImageUrl){
      this.channelsImage = null;
      if(dataImageUrl != null && dataImageUrl.length){
        if (typeof dataImageUrl == 'string') {
          this.channelsImage = dataImageUrl;
        }
        else {
          this.channelsImage = dataImageUrl[0];
        }
      }
    },
    showImage(channelsImage) {
      this.isModalImages = false;
      this.showBigImage = "";

      if(channelsImage){
        this.showBigImage = channelsImage;
        this.isModalImages = true;
      }
    },
    closeModal(){
      this.showBigImage = "";
      this.isModalImages = false;
    },
    getTooltip(data) {
      let channelDetail = '';
      if(data && data == 'Oracle NetSuite'){
        channelDetail = 'Oracle';
      }else if(data){
        channelDetail = data;
      }else{
        channelDetail = 'Manual Product';
      }
      return channelDetail;
    },
  }
}
</script>
<style scoped>
.fade {
    pointer-events: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/tenancy/center/ChannelsLogoComponent.vue